import api from './urlBase'


const CreateProperties = async (validProperties) => {

    try {
        const result = await api.post('create-selected-row-supabase', {
            data: validProperties,
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result.data;
    } catch (error) {
        console.error('Error creating properties:', error);
    }
}

const GetAllProperties = async (objectData={}) => {
    // Get current date for default start_date and end_date
    const currentDate = new Date().toISOString().split('T')[0];
    
    const options = {
        limit: objectData.limit || 10,
        page: objectData.page || 1,
        start_date: objectData.start_date || currentDate,
        end_date: objectData.end_date || currentDate,
        search: objectData.search || ''
    };
    
    console.log('[API] GetAllProperties called with:', options);
    
    try {
        const result = await api.post('get-all-properties', options, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        
        console.log('[API] GetAllProperties raw response:', result.data);
        
        const data = result.data[0]?.data || [];
        
        console.log('[API] GetAllProperties returning:', data.length, 'items');
        
        return data;
    } catch (error) {
        console.error('Error fetching properties:', error);
        return [];
    }
}

const UpdateProperties = async (propertyDetail) => {
    try {
        const result = await api.put('update-automation-property', {
            property_id: propertyDetail.property_id,
            row_id: propertyDetail.id,
            schedule_task_date: propertyDetail.schedule_tasks,
            highlight_on_lamudi: propertyDetail.controlled_highlight_this_listing_lamudi,
            headers: {
                'Content-Type': 'application/json'
            },
            
        });
        return result.data;
    } catch (error) {
        console.error('Error update properties:', error);
    }
}

const DeleteProperties = async (row_id, property_id) => {
    try {
        const result = await api.delete('delete-automation-property', {
            params: { row_id: row_id, property_id: property_id }
        });
        return result.data;
    } catch (error) {
        console.error('Error delete properties:', error);
    }
}

// New methods for automation properties
const GetAllAutomateProperties = async (objectData={}) => {
    // Get current date for default start_date and end_date
    const currentDate = new Date().toISOString().split('T')[0];
    
    const options = {
        limit: objectData.limit || 5,
        length: objectData.length || 2,
        page: objectData.page || 1,
        start_id: objectData.start_id || '',
        end_id: objectData.end_id || '',
        start_date: objectData.start_date || currentDate,
        end_date: objectData.end_date || currentDate,
        order_by: objectData.order_by || 'date',
        search: objectData.search || ''
    };
    
    try {
        const result = await api.post('get-all-listing-properties', options, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result.data;
    } catch (error) {
        console.error('Error fetching automate properties:', error);
        throw error;
    }
}

const CreateAutomateProperties = async (properties) => {
    try {
        const result = await api.post('create-listing-properties', {
            properties: properties
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result.data;
    } catch (error) {
        console.error('Error creating automate properties:', error);
        throw error;
    }
}

const UpdateAutomateProperties = async (properties) => {
    try {
        const result = await api.post('update-listing-properties', {
            properties: properties
        }, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result.data;
    } catch (error) {
        console.error('Error updating automate properties:', error);
        throw error;
    }
}

const DeleteAutomateProperties = async (groupIds) => {
    try {
        const result = await api.delete('delete-listing-properties', {
            data: {
                group_ids: groupIds
            },
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return result.data;
    } catch (error) {
        console.error('Error deleting automate properties:', error);
        throw error;
    }
}

const PropertiesApi = {
    CreateProperties,
    GetAllProperties,
    UpdateProperties,
    DeleteProperties,
    GetAllAutomateProperties,
    CreateAutomateProperties,
    UpdateAutomateProperties,
    DeleteAutomateProperties
}

export default PropertiesApi;
